import { TextInput } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'

import { Input } from '../types'

export const TextFormInput: FunctionComponent<Input<string>> = ({
  name,
  value,
  onChange,
  tKey,
  t,
  tName,
}) => {
  const onInputChange = useCallback(
    (it) => onChange(it === '' ? undefined : it),
    [onChange],
  )

  return (
    <TextInput
      name={name}
      value={value ?? ''}
      onChange={onInputChange}
      placeholder={t<string>(tKey(tName, 'placeholder'))}
    />
  )
}
